module.exports = __webpack_public_path__ + "static/media/iphone-border.905277c5.png";